// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSelectTemplate_root__7G++d"};